import { createComponentMapperModel } from '@wix/editor-elements-integrations';
import {
  props,
  css,
  sdkData,
} from '../../../StylableButton/viewer/StylableButton.mapper';

export default createComponentMapperModel({
  props,
  css,
  sdkData,
});
